import React, { useCallback, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { listDeletionRequests } from '../../api/deletionRequests';
import './DeletionRequestsNavLink.css';

// The page fires this after Close account or Delete data, so the badge does
// not wait for the next navigation.
export const DELETION_REQUESTS_CHANGED = 'deletion-requests-changed';

// Open = not purged yet: requested ones need closing, closed ones still hold data.
const DeletionRequestsNavLink: React.FC = () => {
  const { currentUser } = useAuth();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(0);

  const load = useCallback(async () => {
    if (!currentUser) return;
    try {
      const requests = await listDeletionRequests(await currentUser.getIdToken());
      setOpen(requests.filter(item => item.status !== 'purged').length);
    } catch {
      // The count is a hint; the page itself reports errors.
    }
  }, [currentUser]);

  useEffect(() => {
    load();
  }, [load, pathname]);

  useEffect(() => {
    window.addEventListener(DELETION_REQUESTS_CHANGED, load);
    return () => window.removeEventListener(DELETION_REQUESTS_CHANGED, load);
  }, [load]);

  return (
    <Link to="/deletion-requests">
      Deletion requests
      {open > 0 && (
        <span className="nav-count" aria-label={`${open} open`}>{open}</span>
      )}
    </Link>
  );
};

export default DeletionRequestsNavLink;
